export default __webpack_public_path__ + "static/media/buttons-card-2-active.00d6c5c1.svg";